import { Pipe, PipeTransform } from '@angular/core';
import { linkifyStr } from 'linkifyjs/string';

@Pipe({
  name: 'linkifyStr'
})
export class LinkifyPipe implements PipeTransform {

  transform(str: string): string {
    return str ? linkifyStr(str, {target: '_system'}): str;
  }

}



// WEBPACK FOOTER //
// C:/Users/Domin/OneDrive/Proyectos/GyCPlaza/src/app/linkify.pipe.ts